module.exports = __webpack_public_path__ + "static/img/2.4e612563.jpeg";